import { IFlattenServerErrorResponse, IServerErrorResponse } from '../types';

export const flattenServerErrorResponse = (errorResponse: IServerErrorResponse) : IFlattenServerErrorResponse => {
  const data = errorResponse?.response.data;
  const errors = data?.errors?.[0];
  return {
    reasonPhrase: data?.reasonPhrase || '',
    httpStatus: data?.httpStatus,
    code: errors?.code,
    codeName: errors?.codeName || '',
    localizedMessage: errors?.localizedMessage || '',
    message: errors?.message || '',
    status: errorResponse?.response?.status,
  };
};
